/* eslint-disable operator-linebreak */
import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
//#region Slice Imports
import { useDispatch, useSelector } from "react-redux";
import { useParams, useLocation } from "react-router-dom";
import {
  getWeeklyDuration,
  getWorkSlots,
  addScreenshotImages,
  getMonthTimeline,
  changeSelectedDay,
  getTrackerState,
  updateSelectedDayBasedOnTimezone,
  setMonth
} from "../../Slices/candidateSlice";
import { showModal } from "./../../Slices/sessionSlice";
//#endregion
//#region Components
import MonthPicker from "../../components/MonthPicker/MonthPicker";
import DayTimeLine from "../../containers/DayTimeLine/DayTimeLine";
import MonthTimeLine from "../../containers/MonthTimeLine/MonthTimeLine";
import DayOverview from "../../containers/DayOverview/DayOverview";
import Loading from "./../../components/Loading/Loading";
import useMousePosition from "../../components/MousePosition/MousePosition";
import ImageCarousel from "../../components/ImageCarousel/ImageCarousel";
import ImageCard from "../../components/ImageCard/ImageCard";
import ActivityPercentage from "../../components/ActivityPercentage/ActivityPercentage";
import RestrictUser from "../../components/RestrictUser/RestrictUser";
//#endregion
//#region Container
import EditSlot, { id as editSlotId } from "../../containers/EditSlot/EditSlot";
import AddOfflineSlot, {
  id as addOfflineSlotId,
} from "../../containers/AddOffline/AddOffline";
import SplitSlot, {
  id as splitSlotId,
} from "../../containers/SplitSlot/SplitSlot";
import TimezonePicker from "../../containers/TimeZonePicker/TimeZonePicker";
//#endregion
//#region Helpers
import {
  isToday,
  getWorkSlotActivityPercentage,
  changeTimzone,
} from "../../helpers/stubs";
import { getUserTimeZone } from "../../helpers/browser_stubs";
//#endregion
import moment from "moment";
import momentTimezone from "moment-timezone";
const pollingTimeout = parseInt(process.env.REACT_APP_POLLING_TIMEOUT);

//#region Render Slots
const RenderSlots = ({
  session,
  setfShowCarousel,
  setcurrentIndexOfSessionForCrousal,
  setcurrentIndexOfScreenshotForCrousal,
  sessionIndex,
  client,
  project,
  sessions,
  selectedDay,
  userId,
  splittedSlots,
  selectedCandidate,
  tracker,
  timezone,
}) => {
  const dispatch = useDispatch();
  const isSlotSplitted = splittedSlots.find(
    (slot) => slot._id.toString() === session._id
  );
  const activityPercentage = getWorkSlotActivityPercentage(session);
  // let id = "";
  // if (session.slotType !== "tracker") {
  //   id = "slot";
  // }
  return (
    <>
      <>
        <Row key={String(Math.random())} className="mb-2" id={session._id}>
          <Col>
            <span style={{ padding: 10 }}>
              {`${changeTimzone(session.slotFrom, timezone)
                .format("h:mm a")
                .toUpperCase()}`}
            </span>
            <span style={{ fontSize: 20 }}>-</span>
            <span style={{ padding: 10 }}>
              {`${changeTimzone(session.slotTo, timezone)
                .format("h:mm a")
                .toUpperCase()}`}
            </span>
            <span
              style={{ fontSize: 20 }}
              className={`${session.slotType === "offline" ? "text-danger" : "text-body"
                }`}
            >
              <span>{session.task.name}</span>
              <span>{" > "}</span>
              <span style={{ color: "#0057e7" }}>
                {session.task.project.name}
              </span>
              <span>{" > "}</span>
              <span style={{ color: "#008744" }}>
                {session.task.project.supervisingClient.name}
              </span>
            </span>
            {session.slotType === "offline" && (
              <span style={{ padding: 10, fontSize: 20 }}>(offline)</span>
            )}
            {!selectedCandidate && (
              <svg
                style={{ marginLeft: "10px", cursor: "pointer" }}
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="blue"
                class="ml-5 bi bi-pencil-square"
                viewBox="0 0 16 16"
                onClick={() => {
                  // show Session Edit Modal
                  dispatch(
                    showModal({
                      id: editSlotId,
                      data: session,
                    })
                  );
                }}
              >
                <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                <path
                  fill-rule="evenodd"
                  d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                />
              </svg>
            )}

            {isSlotSplitted && (
              // eslint-disable-next-line jsx-a11y/anchor-is-valid
              <a
                href="#"
                style={{ marginLeft: "10px" }}
                onClick={() => {
                  if (isSlotSplitted.splittedFrom === "head") {
                    dispatch(
                      changeSelectedDay(
                        momentTimezone(selectedDay).tz(timezone).subtract(1, "days").toISOString()
                      )
                    );
                  } else {
                    dispatch(
                      changeSelectedDay(
                        momentTimezone(selectedDay).tz(timezone).add(1, "days").toISOString()
                      )
                    );
                  }
                }}
              >
                Slot Splitted Click to see More
              </a>
            )}
            <ActivityPercentage activityPercentage={activityPercentage} />
          </Col>
        </Row>
        <Row className="justify-content-space-between">
          {session.screenshots &&
            session.screenshots.map((screenshot, screenShotImageIndex) => (
              <ImageCard
                screenShotImageIndex={screenShotImageIndex}
                sessionIndex={sessionIndex}
                setcurrentIndexOfSessionForCrousal={
                  setcurrentIndexOfSessionForCrousal
                }
                setfShowCarousel={setfShowCarousel}
                setcurrentIndexOfScreenshotForCrousal={
                  setcurrentIndexOfScreenshotForCrousal
                }
                url={screenshot.url}
                lowResUrl={screenshot.lowResUrl}
                timeTakenAt={screenshot.timeTakenAt}
                sessions={sessions}
                screenshotId={screenshot._id}
                selectedDay={selectedDay}
                userId={userId}
                showDeleteButton={selectedCandidate ? false : true}
                tracker={tracker}
                timezone={timezone}
              />
            ))}
        </Row>
      </>
    </>
  );
};
//#endregion

function CandidateScreenshots() {
  const [fShowCarousel, setfShowCarousel] = useState(false);

  // eslint-disable-next-line operator-linebreak
  const [currentIndexOfSessionForCrousal, setcurrentIndexOfSessionForCrousal] =
    useState(null);
  const [
    currentIndexOfScreenshotForCrousal,
    setcurrentIndexOfScreenshotForCrousal,
  ] = useState(null);
  const clientList = ["Google", "Apple"];

  const [client, setClient] = useState(clientList[0]);
  const projectList = ["Blue Bird", "Bootstrap"];

  const [project, setProject] = useState(projectList[0]);
  const [canFetchMoreWorkSlots, setCanFetchMoreWorkSlots] = useState(true);

  // const [timezone, setTimezone] = useState([getUserTimeZone()]);

  //#region Store Listeners
  const dispatch = useDispatch();
  const {
    activeModal,
    sessionUser,
    sessionUser: { timezone },
  } = useSelector((state) => state.sessionSlice);
  const {
    workSlots: slots,
    screenshotImages,
    isLoading,
    selectedDay,
    monthTimeline,
    month,
    isFetchingMore,
    splittedSlots,
    tracker,
    isMonthTimeLineFetched,
  } = useSelector((state) => state.candidateSlice);
  //#endregion

  {
    /* console.log("Selected Candidate :- ", selectedCandidate); */
  }

  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const name = Boolean(query.get("name"))
    ? query.get("name").split("**").join("  ")
    : "";
  const candidateId = query.get("candidateId");
  const querySelectedDate = query.get("date") || query.get("selectedDate") || query.get("d") || query.get("sd");
  const hasQueryDate = Boolean(querySelectedDate);
  const userId = sessionUser._id;
  const selectedCandidate = Boolean(query.get("name"))
    ? { candidateId, candidateName: name }
    : null;

  const [ref, mousePosition] = useMousePosition();
  const [queryInitDone, setQueryInitDone] = useState(!hasQueryDate);

  // Helper function to create UTC timestamp where UTC date matches intended date
  // Backend parses ISO string as UTC first, so UTC date must match intended date
  const createUtcTimestampForDate = (dateString, timezone) => {
    // Parse date string in the timezone to get the intended date
    const parsed = momentTimezone.tz(dateString, "YYYY-MM-DD", timezone);
    if (!parsed.isValid()) return null;
    
    // Extract date components (year, month, day) from timezone-aware date
    const year = parsed.year();
    const month = parsed.month(); // 0-11
    const date = parsed.date();
    
    // Create UTC timestamp with same date components at noon UTC (avoids timezone edge cases)
    // This ensures UTC date matches the intended date
    return momentTimezone.utc([year, month, date, 12, 0, 0]).toISOString();
  };

  // #region Fetch More Workslots
  const abortControllerFetchMore = new AbortController();
  useEffect(() => {
    // const today = moment().toISOString();
    // const isToday = moment(today).isSame(selectedDay, "day");
    if (!queryInitDone) return () => abortControllerFetchMore.abort();
    if (canFetchMoreWorkSlots && selectedDay && isToday(selectedDay)) {
      // For fetchMore, use existing slot time or create proper UTC timestamp
      let day = slots[0] ? slots[0].slotFrom : selectedDay;
      // If using selectedDay and we have querySelectedDate, ensure correct format
      if (!slots[0] && querySelectedDate && timezone) {
        const correctedDay = createUtcTimestampForDate(querySelectedDate, timezone);
        if (correctedDay) {
          day = correctedDay;
        }
      }
      setCanFetchMoreWorkSlots(false);
      //#region Fetch New WorkSlots
      const payload = { userId, day, fetchMore: true, timezone };
      const weeklyDurationPayload = {
        userId: userId,
        day: day, // Use same day format
        timezone,
      };
      if (candidateId) {
        payload.candidateId = candidateId;
        weeklyDurationPayload.candidateId = candidateId;
      }
      dispatch(getWorkSlots(payload));
      //#endregion
      //#region Fetch new weekly durations
      dispatch(getWeeklyDuration(weeklyDurationPayload));
      //#endregion
      // #region setTimeout for user to be able to fetch more workslot again
      setTimeout(() => {
        {
          /* console.log("canfetch more now"); */
        }
        setCanFetchMoreWorkSlots(true);
      }, pollingTimeout);
      // #endregion
    }
    return () => {
      abortControllerFetchMore.abort();
    };
  }, [mousePosition]);
  // #endregion

  // #region Get Tracker State
  useEffect(() => {
    if (!selectedCandidate) {
      dispatch(getTrackerState());
    }
  }, [activeModal]);
  // #endregion

  // #region Initialize selected day and month from query param `d` using MonthTimeLine logic
  useEffect(() => {
    if (querySelectedDate && timezone) {
      const selectedIso = createUtcTimestampForDate(querySelectedDate, timezone);
      if (selectedIso) {
        dispatch(changeSelectedDay(selectedIso));
        dispatch(setMonth({ month: selectedIso, monthChangedTo: null }));
        setQueryInitDone(true);
      } else {
        // Invalid date in query: fall back to existing behavior and proceed
        setQueryInitDone(true);
      }
    }
  }, [querySelectedDate, timezone, dispatch]);
  // #endregion

  // Observe selectedDay changes
  useEffect(() => {}, [selectedDay, timezone]);

  //#region Get Work Slots
  const abortControllerGetWorkSlots = new AbortController();
  useEffect(() => {
    if (!queryInitDone) return () => abortControllerGetWorkSlots.abort();
    // Ensure UTC date matches intended date for backend compatibility
    // Backend parses ISO string as UTC first, so UTC date must match intended date
    let dayToSend = selectedDay;
    if (querySelectedDate && timezone) {
      const correctedDay = createUtcTimestampForDate(querySelectedDate, timezone);
      if (correctedDay) {
        dayToSend = correctedDay;
      }
    }
    const payload = { userId, day: dayToSend, fetchMore: false, timezone };
    if (candidateId) {
      payload.candidateId = candidateId;
    }
    dispatch(getWorkSlots(payload));
    return () => {
      abortControllerGetWorkSlots.abort();
    };
  }, [selectedDay, timezone, queryInitDone, querySelectedDate, candidateId, userId]);
  //#endregion

  //#region Get Weekly Duration
  const abortControllerGetWeeklySlots = new AbortController();
  useEffect(() => {
    if (!queryInitDone) return () => abortControllerGetWeeklySlots.abort();
    // Ensure UTC date matches intended date for backend compatibility
    let dayToSend = selectedDay;
    if (querySelectedDate && timezone) {
      const correctedDay = createUtcTimestampForDate(querySelectedDate, timezone);
      if (correctedDay) {
        dayToSend = correctedDay;
      }
    }
    const weeklyDurationPayload = {
      userId: userId,
      day: dayToSend,
      timezone,
    };
    if (candidateId) {
      weeklyDurationPayload.candidateId = candidateId;
    }
    dispatch(getWeeklyDuration(weeklyDurationPayload));
    return () => {
      abortControllerGetWeeklySlots.abort();
    };
  }, [selectedDay, timezone, queryInitDone, querySelectedDate, candidateId, userId]);
  //#endregion

  //#region Month Timeline Effect
  const abortControllerMonthtimeline = new AbortController();
  useEffect(() => {
    if (!queryInitDone) return () => abortControllerMonthtimeline.abort();
    const monthTimelinePayload = {
      userId,
      timezone,
      selectedDay: month,
    };
    if (candidateId) {
      monthTimelinePayload.candidateId = candidateId;
    }
    dispatch(getMonthTimeline(monthTimelinePayload));
    return () => {
      abortControllerMonthtimeline.abort();
    };
  }, [month, timezone, queryInitDone]);
  //#endregion

  //#region Generate Screenshot Images List
  const generateScreenshotImagesList = () => {
    const screenshotImages = [];
    slots.forEach((slot) => {
      if (slot.screenshots) {
        slot.screenshots.forEach((screenshot) => {
          screenshotImages.push({
            url: screenshot.url,
            _id: screenshot._id,
            timeTakenAt: screenshot.timeTakenAt,
            task: slot.task,
          });
        });
      }
    });
    dispatch(addScreenshotImages({ screenshotImages }));
  };
  useEffect(() => {
    generateScreenshotImagesList();
  }, [slots]);

  // #region Deriving Current Task
  let currentTask = null;
  if (slots.length !== 0 && isToday(selectedDay)) {
    const trackerSlotIndex = slots.findIndex(
      (item) => item.slotType === "tracker"
    );
    if (trackerSlotIndex !== -1) {
      currentTask = slots[trackerSlotIndex].task;
    }
  }
  // #endregion

  //#endregion
  return (
    <div ref={ref}>
      {isLoading && <Loading />}
      {!isLoading && (
        <Container className="p-0">
          <Row className="my-2 shadow-sm p-3 mb-5 bg-body rounded align-items-center">
            <Col sm="3">{<TimezonePicker />}</Col>
            {selectedCandidate && (
              <Col className="align-items-center text-end">
                <span className="h6">{selectedCandidate.candidateName}</span>
              </Col>
            )}
            {!selectedCandidate && (
              <Col sm="6" className="text-end">
                <Button
                  variant="outline-primary"
                  onClick={() => {
                    dispatch(
                      showModal({
                        id: addOfflineSlotId,
                      })
                    );
                  }}
                >
                  + Offline Time
                </Button>
              </Col>
            )}

            <Col className="align-items-center" sm="3">
              <MonthPicker month={month} />
            </Col>
          </Row>
          {isMonthTimeLineFetched === false ? (
            <Loading />
          ) : (
            <>
              <MonthTimeLine month={month} />
              <DayOverview currentTask={currentTask} candidateId={candidateId} />
              <DayTimeLine />
            </>
          )}
          {isFetchingMore && <Loading />}
          {slots.map((session, sessionIndex, sessions) => (
            <Row
              key={String(Math.random())}
              className="my-2 shadow-sm p-3 mb-5 bg-body rounded"
            >
              <Col key={String(Math.random())}>
                <RenderSlots
                  session={session}
                  setfShowCarousel={setfShowCarousel}
                  setcurrentIndexOfSessionForCrousal={
                    setcurrentIndexOfSessionForCrousal
                  }
                  setcurrentIndexOfScreenshotForCrousal={
                    setcurrentIndexOfScreenshotForCrousal
                  }
                  sessionIndex={sessionIndex}
                  client={client}
                  project={project}
                  sessions={sessions}
                  selectedDay={selectedDay}
                  userId={userId}
                  splittedSlots={splittedSlots}
                  selectedCandidate={selectedCandidate}
                  tracker={tracker}
                  timezone={timezone}
                />
              </Col>
            </Row>
          ))}
          {Boolean(activeModal) &&
            tracker === "running" &&
            [editSlotId, addOfflineSlotId, splitSlotId].includes(
              activeModal.id
            ) && <RestrictUser />}
          {Boolean(activeModal) &&
            activeModal.id === editSlotId &&
            tracker !== "running" && <EditSlot data={activeModal.data} />}
          {Boolean(activeModal) &&
            activeModal.id === addOfflineSlotId &&
            tracker !== "running" && <AddOfflineSlot />}
          {Boolean(activeModal) &&
            activeModal.id === splitSlotId &&
            tracker !== "running" && <SplitSlot data={activeModal.data} />}
        </Container>
      )}
      {fShowCarousel && (
        <ImageCarousel
          sessions={slots}
          currentIndexOfScreenshotForCrousal={
            currentIndexOfScreenshotForCrousal
          }
          currentIndexOfSessionForCrousal={currentIndexOfSessionForCrousal}
          setfShowCarousel={setfShowCarousel}
          screenshotImages={screenshotImages}
          showDeleteButton={true}
          userId={userId}
          tracker={tracker}
          selectedDay={selectedDay}
        />
      )}
    </div>
  );
}

export default CandidateScreenshots;
